import React, { memo, useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Box } from '@mui/material';
import { SearchInput } from '@provider-portal/common/components/SearchInput';
import { push } from 'connected-react-router';
import queryString from 'query-string';

import { selectQuery } from 'rdx/router';

import { useDebounce } from 'root/hooks/useDebounce';

import MenuControls from './MenuControls';
import SaveChanges from './SaveChanges';

interface MenuContentHeaderProps {
  onSave: () => void;
  onReset: () => void;
  isSavingDisabled: boolean;
}

const MenuContentHeader: React.FC<MenuContentHeaderProps> = ({
  onSave,
  onReset,
  isSavingDisabled,
}) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const query = useSelector(selectQuery);
  const [value, setValue] = useState(query.search || '');
  const debouncedValue = useDebounce<string>(value, 500);

  const handleSearchChange = useCallback((searchStr: string) => {
    setValue(searchStr);
  }, []);

  const handleReset = useCallback(() => {
    setValue('');
    onReset();
  }, [onReset]);

  useEffect(() => {
    dispatch(
      push({
        search: queryString.stringify({
          selectedCategoryId: query.selectedCategoryId,
          search: debouncedValue,
        }),
      }),
    );
  }, [debouncedValue, dispatch, query.selectedCategoryId]);

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      mb={2}
      mx={3}
    >
      <Box width={350}>
        <SearchInput
          searchLabel={formatMessage({ id: 'components.ItemsList.searchLabel' })}
          onChange={handleSearchChange}
        />
      </Box>
      {query.mode === 'edit' ? (
        <SaveChanges onSave={onSave} isSavingDisabled={isSavingDisabled} onReset={handleReset} />
      ) : (
        <MenuControls />
      )}
    </Box>
  );
};

export default memo(MenuContentHeader);
